import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "breadcrumb" }
const _hoisted_2 = { class: "dark-section" }
const _hoisted_3 = { class: "strip" }
const _hoisted_4 = { class: "recent-alerts-scroll" }
const _hoisted_5 = { class: "alert-card__body" }
const _hoisted_6 = { class: "alert-card__title" }
const _hoisted_7 = { class: "alert-card__message" }
const _hoisted_8 = { class: "alert-card__meta" }
const _hoisted_9 = { class: "alert-card__device" }
const _hoisted_10 = { class: "alert-card__time" }
const _hoisted_11 = {
  key: 0,
  class: "recent-empty"
}
const _hoisted_12 = { class: "strip" }
const _hoisted_13 = { class: "strip-header" }
const _hoisted_14 = { class: "search-wrap" }
const _hoisted_15 = { class: "filters-grid" }
const _hoisted_16 = { class: "filter-row" }
const _hoisted_17 = { class: "filter-chips" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "cat-card__icon" }
const _hoisted_20 = { class: "cat-card__label" }
const _hoisted_21 = { class: "cat-card__badge" }
const _hoisted_22 = {
  key: 0,
  class: "recent-empty"
}
const _hoisted_23 = {
  key: 0,
  class: "filter-row"
}
const _hoisted_24 = { class: "filter-chips" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "cat-card__label" }
const _hoisted_27 = { class: "cat-card__badge" }
const _hoisted_28 = { class: "filter-row" }
const _hoisted_29 = { class: "filter-chips" }
const _hoisted_30 = { class: "cat-card__badge" }
const _hoisted_31 = { class: "cat-card__badge" }
const _hoisted_32 = { class: "alerts-wrapper" }
const _hoisted_33 = { class: "tbl-wrap" }
const _hoisted_34 = { class: "tbl" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  key: 0,
  class: "status-badge resolved"
}
const _hoisted_38 = {
  key: 1,
  class: "status-badge pending"
}
const _hoisted_39 = { class: "mono" }
const _hoisted_40 = {
  key: 0,
  class: "user-cell"
}
const _hoisted_41 = {
  key: 1,
  class: "device-cell"
}
const _hoisted_42 = { class: "msg-cell" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["colspan"]
const _hoisted_47 = {
  key: 0,
  class: "load-more"
}
const _hoisted_48 = ["disabled"]

import { useNotifications } from "@/composables/useNotifications";
import NotificationBell from "./NotificationBell.vue";
import { inject, onMounted, ref, computed, type Ref } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertsPage',
  setup(__props) {

const isDesktop = inject<Ref<boolean>>("isDesktop")!;
const isSidebarOpen = inject<Ref<boolean>>("isSidebarOpen")!;

const showCrumbBell = computed(
  () => !isDesktop.value || (isDesktop.value && !isSidebarOpen.value)
);

const { state, fetchLatest, setMaxLimit } = useNotifications();
const loading = ref(false);
const currentLimit = ref(20);

// ─── Stato sezioni collassabili ───────────────────────────────────────────
const recentOpen = ref(false);
const filtersOpen = ref(false);

// ─── Stato filtri ─────────────────────────────────────────────────────────
const activeCategory = ref<string | null>(null);
const activeSeverity = ref<string | null>(null);
const activeStatus = ref<'resolved' | 'pending' | null>(null);
const searchQuery = ref('');

// ─── Helpers ──────────────────────────────────────────────────────────────
const isAlert = (n: any) =>
  n?.severity === "error" ||
  n?.severity === "warning" ||
  n?.payload?.kind === "alert";

const isResolved = (n: any) =>
  !!(
    n?.is_read ||
    n?.resolved ||
    n?.payload?.resolved ||
    n?.status === "resolved" ||
    n?.graph_status === "ok"
  );

function formatWhen(n: any) {
  const ts = n.createdAt ?? n.created_at;
  try {
    return ts ? new Date(ts).toLocaleString() : "";
  } catch {
    return "";
  }
}

function relativeTime(n: any) {
  const ts = n.createdAt ?? n.created_at;
  if (!ts) return "";
  const diff = Date.now() - new Date(ts).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "adesso";
  if (mins < 60) return `${mins}m fa`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h fa`;
  return `${Math.floor(hrs / 24)}g fa`;
}

function truncate(str: string | undefined, max: number) {
  if (!str) return "—";
  return str.length > max ? str.slice(0, max) + "…" : str;
}

function severityColor(severity: string | undefined) {
  const map: Record<string, string> = {
    error: "#ff3b30",
    warning: "#ffcc00",
    info: "#00b3b3",
  };
  return map[severity ?? ""] ?? "#555";
}

// ─── Mappa categorie ──────────────────────────────────────────────────────
const CATEGORY_LABELS: Record<string, string> = {
  graph_status_change: "Cambi di Stato",
  graph_deleted: "Eliminati",
  graph_archived: "Archiviati",
  graph_created: "Creati",
  graph_updated: "Aggiornati",
  graph_restored: "Ripristinati",
  permission_request: "Permessi",
};

const CATEGORY_ICONS: Record<string, string> = {
  graph_status_change: "⚡",
  graph_deleted: "🗑️",
  graph_archived: "📦",
  graph_created: "✨",
  graph_updated: "✏️",
  graph_restored: "♻️",
  permission_request: "🔑",
};

function categoryIcon(type: string) {
  return CATEGORY_ICONS[type] ?? "📋";
}

function selectCategory(type: string | null) {
  activeCategory.value = activeCategory.value === type ? null : type;
}

function selectSeverity(s: string) {
  activeSeverity.value = activeSeverity.value === s ? null : s;
}

function selectStatus(s: 'resolved' | 'pending') {
  activeStatus.value = activeStatus.value === s ? null : s;
}

function clearAllFilters() {
  activeCategory.value = null;
  activeSeverity.value = null;
  activeStatus.value = null;
  searchQuery.value = '';
}

// ─── Computed ─────────────────────────────────────────────────────────────
const allAlerts = computed(() => state.items.filter(isAlert));

const recentAlerts = computed(() => allAlerts.value.slice(0, 5));

const categories = computed(() => {
  const counts: Record<string, number> = {};
  for (const n of allAlerts.value)
    if (n.type) counts[n.type] = (counts[n.type] ?? 0) + 1;
  return Object.entries(counts)
    .filter(([, c]) => c > 0)
    .map(([type, count]) => ({
      type,
      label: CATEGORY_LABELS[type] ?? type,
      count,
    }));
});

const SEVERITY_LABELS: Record<string, string> = {
  error: 'Errori',
  warning: 'Avvisi',
  info: 'Info',
  success: 'Successi',
};

const severities = computed(() => {
  const counts: Record<string, number> = {};
  for (const n of allAlerts.value)
    if (n.severity) counts[n.severity] = (counts[n.severity] ?? 0) + 1;
  return Object.entries(counts)
    .filter(([, c]) => c > 0)
    .map(([severity, count]) => ({
      severity,
      label: SEVERITY_LABELS[severity] ?? severity,
      count,
    }));
});

const statusCounts = computed(() => ({
  pending: allAlerts.value.filter(n => !isResolved(n)).length,
  resolved: allAlerts.value.filter(n => isResolved(n)).length,
}));

const hasAnyFilter = computed(() =>
  activeCategory.value !== null ||
  activeSeverity.value !== null ||
  activeStatus.value !== null ||
  searchQuery.value.trim() !== ''
);

const filteredItems = computed(() => {
  let items = allAlerts.value;
  if (activeCategory.value)
    items = items.filter(n => n.type === activeCategory.value);
  if (activeSeverity.value)
    items = items.filter(n => n.severity === activeSeverity.value);
  if (activeStatus.value === 'resolved')
    items = items.filter(n => isResolved(n));
  if (activeStatus.value === 'pending')
    items = items.filter(n => !isResolved(n));
  if (searchQuery.value.trim()) {
    const q = searchQuery.value.trim().toLowerCase();
    items = items.filter(n =>
      n.message?.toLowerCase().includes(q) ||
      n.graph_name?.toLowerCase().includes(q) ||
      n.email?.toLowerCase().includes(q) ||
      n.username?.toLowerCase().includes(q)
    );
  }
  return items;
});

const canFetchMore = computed(() =>
  state.items.length >= currentLimit.value && filteredItems.value.length > 0
);

async function loadMore() {
  loading.value = true;
  currentLimit.value += 20;
  setMaxLimit(currentLimit.value);
  await fetchLatest({ limit: currentLimit.value });
  loading.value = false;
}

onMounted(async () => {
  loading.value = true;
  setMaxLimit(currentLimit.value);
  await fetchLatest({ limit: currentLimit.value });
  loading.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _cache[5] || (_cache[5] = _createElementVNode("span", null, "Alerts", -1)),
      _cache[6] || (_cache[6] = _createElementVNode("div", { style: {"flex-grow":"1"} }, null, -1)),
      (showCrumbBell.value)
        ? (_openBlock(), _createBlock(NotificationBell, {
            key: 0,
            placement: "header"
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("button", {
          class: "strip-toggle",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (recentOpen.value = !recentOpen.value))
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "strip-title" }, "Ultimi Alert", -1)),
          _createElementVNode("span", {
            class: _normalizeClass(["strip-chevron", { open: recentOpen.value }])
          }, "›", 2)
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentAlerts.value, (n) => {
            return (_openBlock(), _createElementBlock("div", {
              key: n.id,
              class: "alert-card",
              style: _normalizeStyle({ borderLeftColor: severityColor(n.severity) })
            }, [
              _createElementVNode("div", {
                class: "alert-card__severity-bar",
                style: _normalizeStyle({ background: severityColor(n.severity) })
              }, null, 4),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(n.title || 'Aggiornamento'), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(truncate(n.message, 80)), 1),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(n.graph_name || n.graph_id || '—'), 1),
                  _createElementVNode("span", _hoisted_10, _toDisplayString(relativeTime(n)), 1)
                ])
              ])
            ], 4))
          }), 128)),
          (recentAlerts.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, " Nessun alert recente. "))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, recentOpen.value]
        ])
      ]),
      _createElementVNode("section", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("button", {
            class: "strip-toggle",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (filtersOpen.value = !filtersOpen.value))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("h2", { class: "strip-title" }, "Filtri", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["strip-chevron", { open: filtersOpen.value }])
            }, "›", 2)
          ]),
          (hasAnyFilter.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn-all",
                onClick: clearAllFilters
              }, " Azzera filtri "))
            : _createCommentVNode("", true)
        ]),
        _withDirectives(_createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
              class: "search-input",
              type: "text",
              placeholder: "Cerca per messaggio, device, utente…"
            }, null, 512), [
              [_vModelText, searchQuery.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[9] || (_cache[9] = _createElementVNode("span", { class: "filter-row__label" }, "Categoria", -1)),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (cat) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: cat.type,
                    class: _normalizeClass(["cat-card", { active: activeCategory.value === cat.type }]),
                    onClick: ($event: any) => (selectCategory(cat.type))
                  }, [
                    _createElementVNode("span", _hoisted_19, _toDisplayString(categoryIcon(cat.type)), 1),
                    _createElementVNode("span", _hoisted_20, _toDisplayString(cat.label), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(cat.count), 1)
                  ], 10, _hoisted_18))
                }), 128)),
                (categories.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, " Nessuna categoria disponibile. "))
                  : _createCommentVNode("", true)
              ])
            ]),
            (severities.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _cache[10] || (_cache[10] = _createElementVNode("span", { class: "filter-row__label" }, "Severità", -1)),
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(severities.value, (sv) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: sv.severity,
                        class: _normalizeClass(["cat-card", { active: activeSeverity.value === sv.severity }]),
                        style: _normalizeStyle(activeSeverity.value === sv.severity ? { borderLeftColor: severityColor(sv.severity), borderLeftWidth: '3px' } : {}),
                        onClick: ($event: any) => (selectSeverity(sv.severity))
                      }, [
                        _createElementVNode("span", _hoisted_26, _toDisplayString(sv.label), 1),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(sv.count), 1)
                      ], 14, _hoisted_25))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_28, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "filter-row__label" }, "Stato", -1)),
              _createElementVNode("div", _hoisted_29, [
                (statusCounts.value.pending > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: _normalizeClass(["cat-card", { active: activeStatus.value === 'pending' }]),
                      style: _normalizeStyle(activeStatus.value === 'pending' ? { borderLeftColor: '#ff9800', borderLeftWidth: '3px' } : {}),
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (selectStatus('pending')))
                    }, [
                      _cache[11] || (_cache[11] = _createElementVNode("span", { class: "cat-card__label" }, "⏳ Non risolti", -1)),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(statusCounts.value.pending), 1)
                    ], 6))
                  : _createCommentVNode("", true),
                (statusCounts.value.resolved > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: _normalizeClass(["cat-card", { active: activeStatus.value === 'resolved' }]),
                      style: _normalizeStyle(activeStatus.value === 'resolved' ? { borderLeftColor: '#1e7e34', borderLeftWidth: '3px' } : {}),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (selectStatus('resolved')))
                    }, [
                      _cache[12] || (_cache[12] = _createElementVNode("span", { class: "cat-card__label" }, "✅ Risolti", -1)),
                      _createElementVNode("span", _hoisted_31, _toDisplayString(statusCounts.value.resolved), 1)
                    ], 6))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ], 512), [
          [_vShow, filtersOpen.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("table", _hoisted_34, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _cache[14] || (_cache[14] = _createElementVNode("th", null, "Stato", -1)),
              _cache[15] || (_cache[15] = _createElementVNode("th", null, "Data", -1)),
              (_unref(state).isAdmin)
                ? (_openBlock(), _createElementBlock("th", _hoisted_35, "Utente"))
                : _createCommentVNode("", true),
              (_unref(state).isAdmin)
                ? (_openBlock(), _createElementBlock("th", _hoisted_36, "Device"))
                : _createCommentVNode("", true),
              _cache[16] || (_cache[16] = _createElementVNode("th", null, "Tipo", -1)),
              _cache[17] || (_cache[17] = _createElementVNode("th", null, "Messaggio", -1))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredItems.value, (n) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: n.id,
                class: _normalizeClass([n.severity, { 'resolved': isResolved(n) }])
              }, [
                _createElementVNode("td", null, [
                  (isResolved(n))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, " Risolto "))
                    : (_openBlock(), _createElementBlock("span", _hoisted_38, " In attesa "))
                ]),
                _createElementVNode("td", _hoisted_39, _toDisplayString(formatWhen(n)), 1),
                (_unref(state).isAdmin)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_40, _toDisplayString(n.email || n.username || '—'), 1))
                  : _createCommentVNode("", true),
                (_unref(state).isAdmin)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(n.graph_name || n.graph_id || '—'), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(['label', `label--${n.severity || 'info'}`])
                  }, _toDisplayString(n.title || 'Aggiornamento'), 3)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_42, [
                    (n.payload?.kind === 'alert' && n.title?.toLowerCase().includes('umidità'))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43))
                      : (n.payload?.kind === 'alert' && n.title?.toLowerCase().includes('temperatura'))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_44))
                        : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(n.message || '—'), 1)
                  ])
                ])
              ], 2))
            }), 128)),
            (filteredItems.value.length === 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                  _createElementVNode("td", {
                    colspan: _unref(state).isAdmin ? 6 : 4,
                    class: "empty-msg"
                  }, " Nessun alert trovato. ", 8, _hoisted_46)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      (canFetchMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
            _createElementVNode("button", {
              class: "btn-primary",
              onClick: loadMore,
              disabled: loading.value
            }, _toDisplayString(loading.value ? 'Caricamento...' : 'Carica altri'), 9, _hoisted_48)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})